import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-razao-social',
  templateUrl: './text-razao-social.component.html',
  styleUrls: ['./text-razao-social.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextRazaoSocialComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
